import React from 'react';
import {List, ListItem, Paper} from "@mui/material";
import Typography from "@mui/material/Typography";
import {useSelector} from "react-redux";
import {getItineraryFH} from "../../../utils/utils";
import ItineraryActivityDate from "./ItineraryActivityDate";


const Itinerary = ({removable = true}) => {
    const activities = useSelector(state => state.activities);
    const {extra} = useSelector(state => state.transactions);

    const itinerary = getItineraryFH(activities, {extra});

    return (
        <Paper className={'summaryContainer'}  elevation={3} style={{marginTop: 20}}>
                <List style={{width: '100%', paddingBottom: 0, paddingTop: 0}}>
                    <ListItem alignItems={"flex-start"} style={{margin: 0, padding: '10px 2px 0'}}>
                        <Typography variant="h4" align="left" style={{padding:'10px 12px 10px'}}>
                            Itinerary
                        </Typography>
                    </ListItem>
                    {Object.keys(itinerary).map(date => (
                        <ItineraryActivityDate key={date} date={date} activities={itinerary[date]} removable={removable} />
                    ))}
                </List>
        </Paper>

    );
};

export default Itinerary;